import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import React, { useState } from 'react';
import AuthCheck from 'components/Shared/AuthCheck';
import OrganizationsDataGrid from 'components/AdminConfig/Organizations/OrganizationsDataGrid';
import OrganizationForm from './OrganizationForm';

const tabs = [
    new Tab({ label: "Organizations", value: "Organizations", scope: "AdminConfig", action: "create" }),
    new Tab({ label: "Add Organization", value: "AddOrganization", scope: "AdminConfig", action: "create" })
]

const Organizations = () => {
    const [activeTab, setActiveTab] = useState("Organizations");

    return (
        <AuthCheck scope="AdminConfig" action="create">
            <div style={{height: 25}} />
            <TabbedPage tabSetterFunc={setActiveTab} tabs={tabs} activeTab={activeTab} elevation={0}>
                {(() => {
                    switch (activeTab) {
                        case "Organizations": return <OrganizationsDataGrid></OrganizationsDataGrid>
                        case "AddOrganization": return <OrganizationForm defaultValues={{}} orientation="Horizontal" CRUDType="INSERT" callback={() => setActiveTab("Organizations")} />
                        default: return <OrganizationsDataGrid></OrganizationsDataGrid>
                    }
                })()}
            </TabbedPage>
        </AuthCheck>
    )

};

export default Organizations;